import {useNavigate} from "react-router-dom";
import {Button, YStack} from "@chayka/ui";

export const SignInOrSignUp = () => {
  const navigate = useNavigate();

  return (
    <YStack className="gap-2 items-stretch">
      <Button onClick={() => navigate("/auth/sign-in")}>Войти</Button>
      <div className="text-secondary-text text-sm text-center">или</div>
      <Button onClick={() => navigate("/auth/sign-up")} variant="secondary">
        Зарегистрироваться
      </Button>
    </YStack>
  );
};
